export const AI_TAG_MATERIALS_ON_PAGE = 25;
